import { render, staticRenderFns } from "./ReceivePcn.vue?vue&type=template&id=7e5ec384&scoped=true"
import script from "./ReceivePcn.vue?vue&type=script&lang=js"
export * from "./ReceivePcn.vue?vue&type=script&lang=js"
import style0 from "./ReceivePcn.vue?vue&type=style&index=0&id=7e5ec384&prod&lang=css"
import style1 from "./ReceivePcn.vue?vue&type=style&index=1&id=7e5ec384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5ec384",
  null
  
)

export default component.exports